export default __webpack_public_path__ + "static/media/local_shipping.c8a067da.svg";